module.exports = __webpack_public_path__ + "static/img/propaganda-4.a664fe5f.jpeg";